import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, ModalBody, ModalHeader, ModalFooter, Button, Alert } from "shards-react";
import PageTitle from "./../components/common/PageTitle";
import { useAuth } from '../contexts/AuthContext';
import useGetUsers from "../hooks/useGetUsers"
import UserAccDetailsTable from "../components/components-overview/UserAccDetailsTable";
import UserAccountDetails from "../components/user-profile-lite/UserAccountDetails"
import UserInvoiceTable from "../components/components-overview/UserInvoiceTable";
import updateInvoices from "../hooks/updateInvoices";
import AddInvoiceCard from "../components/components-overview/AddInvoiceCard";
import SkeletonArticle from "../components/skeleton/SkeletonArticle";
import isUserAdmin from "../utils/isUserAdmin";
import { ToastContainer, Slide } from "react-toastify";
import deleteUser from "../hooks/deleteUser"

const AdminDashboard = () => {
  // Constants 
  const { currentUser, resetPassword } = useAuth();
  const { docs } = useGetUsers("users");
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState(null)
  const [selectedUser, setSelectedUser] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [error, setError] = useState();

  // Init setInvoice after page load, updating when new selection/ when user table changes.
  useEffect(() => {
    setInvoices(selectedUser && docs.filter(doc => { return doc.id === selectedUser.id })[0].invoices)
  }, [docs, selectedUser])

  const handleUserSelection = (user) => {
    const selectedUser = docs.filter(doc => doc.id === user)
    setSelectedUser(selectedUser[0])
  }

  const handleDeleteInvoice = async (invoice_id) => {
    if (!loading && isUserAdmin(currentUser)) {
      setLoading(true);
      const newInvoices = invoices.filter(invoice => {
        return invoice.invoice_id !== invoice_id;
      })
      setInvoices(newInvoices);
      const { error } = await updateInvoices(selectedUser.id, newInvoices);
      error && console.log(error);
      setLoading(false);
    }
  }

  function toggleModal() {
    selectedUser && setModalOpen(!modalOpen);
  }

  async function handleDeleteUser() {
    if (isUserAdmin(currentUser) && selectedUser.id !== currentUser.uid) {
      try {
        setLoading(true);
        setError('')
        console.log(`You are deleting ${selectedUser.id}`)
        await deleteUser(selectedUser.id)
        
        // reset constants after user deletion
        setSelectedUser(null)
        setInvoices(null)
      } catch {
        setError('Something went wrong')
      }
      toggleModal()
      setLoading(false)
    }else{
      setError('You cannot delete that user!')
    }
  }

  return (
    <>
      {/* Success Toast when user successfully deleted */}
      <ToastContainer
        position="top-center"
        newestOnTop={true}
        closeOnClick
        rtl={false}
        transition={Slide}
        pauseOnHover={false}
      />

      {/* // Modal for user deletion confrimation  */}
      {selectedUser && <Modal centered open={modalOpen} toggle={toggleModal}>
        <ModalHeader>Are you sure?</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <label>Email</label>
              <p>{selectedUser.email}</p>
            </Col>
            <Col>
              <label>Username</label>
              <p> {selectedUser.username}</p>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => toggleModal()} theme="primary">Cancel</Button>
          <Button disabled={loading} onClick={() => handleDeleteUser()} theme="danger">Confirm Delete User</Button>
        </ModalFooter>
      </Modal>}

      {error && <Alert theme="danger">{error}</Alert>}

      <Container fluid className="px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle title="Admin Dashboard" subtitle={currentUser.username ? currentUser.username : 'Your Company'} className="text-sm-left mb-3" />
        </Row>
        <Row>
          <Col lg="8">
            {!docs.length > 0 && <SkeletonArticle />}
            {docs.length > 0 && <UserAccDetailsTable invoices={invoices} docs={docs} handleUserSelection={handleUserSelection} selectedUser={selectedUser} />}
          </Col>
          <Col>
            <UserAccountDetails resetPassword={resetPassword} selectedUser={selectedUser} toggleModal={toggleModal} />
          </Col>
        </Row>
        <Row>
          <Col lg="4">
            <UserInvoiceTable invoices={invoices} docs={docs} handleDeleteInvoice={handleDeleteInvoice} selectedUser={selectedUser} loading={loading} />
          </Col>
          <Col lg="4">
            <AddInvoiceCard docs={docs} selectedUser={selectedUser} />  
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AdminDashboard;